import { TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { API, SERVER_DOMAIN } from "../../assets/staticData";
import { toast } from "react-toastify";
import { createSlug } from "../../utils/slug";

let userToken = localStorage.getItem("userToken");

export default function EditCats({
  itemToEdit,
  setItemToEdit,
  endpoint,
  refresh,
  setRefresh,
}) {
  const [input, setInput] = useState({});

  const fileInputRef = useRef();

  const ref = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setItemToEdit({});
      setInput(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    async function fetchData() {
      if (Object.keys(itemToEdit).length > 0) {
        try {
          const response = await fetch(
            `${API}/${endpoint}/${itemToEdit.id}?populate=*`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userToken}`,
              },
              method: "GET",
            }
          );
          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }
          const res = await response.json();
          setInput(res.data.attributes);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }

    fetchData();
  }, [itemToEdit]);

  const handleInputChange = (field, value) => {
    setInput({
      ...input,
      [field]: value,
    });
  };

  const saveChanges = () => {

    if (input.category === "" || input.lang === "" || !input.slug.length) {
      toast("Please fill in all the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
      return;
    }

    fetch(`${API}/${endpoint}/${itemToEdit.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: {
          category: input.category,
          desc: input.desc,
          slug: input.slug
        },
      }),
    })
      .then(async (res) => {
        if (res.ok) {
          setRefresh(!refresh);
          setItemToEdit({});
          setInput(null);

          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
          toast("Updated Successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        } else {
          const errorData = await res.json();
          console.error("Error updating entry:", errorData);
          toast("Error updating entry", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        toast("Error updating entry", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "error",
        });
      });
  };

  const automateSlug = () => {

    let content = ""
    if (input.slug?.length) {
      content = input.slug.trim()
    } else if (input.category?.length) {
      content = input.category.trim()
    }

    const slug = createSlug(content);

    setInput(prevInput => ({
      ...prevInput,
      slug
    }));
  };

  return (
    <div
      style={{
        backgroundColor: "#00000020",
        position: "fixed",
        width: "100vw",
        height: "100vh",
        zIndex: 99999999,
        top: 0,
        left: 0,
        opacity: Object.keys(itemToEdit).length > 0 ? 1 : 0,
        visibility: Object.keys(itemToEdit).length > 0 ? "visible" : "hidden",
        transition: "0.3s",
      }}
      className="flex"
    >
      <div
        ref={ref}
        style={{
          width: "70%",
          width: 600,
          height: "auto",
          backgroundColor: "#fff",
          borderRadius: 15,
          transition: "0.3s",
          padding: "4rem 2rem",
        }}
      >
        {input && (
          <div
            className="fadeInFast"
            style={{
              marginTop: 10,
              marginBottom: 20,
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              transition: "0.3s",
            }}
          >
            <TextField
              label="Category Name"
              sx={{ width: "90%" }}
              value={input.category}
              onChange={(e) => handleInputChange("category", e.target.value)}
            />
            <TextField
              label="Description"
              sx={{ width: "90%", mt: 2, mb: 2 }}
              multiline
              rows={6}
              value={input.desc}
              onChange={(e) => handleInputChange("desc", e.target.value)}
            />

            <div className="mt-1 w-[90%]  mb-2">
              <TextField
                label="Slug"
                sx={{ width: "100%" }}
                value={input.slug}
                onChange={(e) => handleInputChange("slug", e.target.value)}
              />
              <div className="mt-1 w-full mr-6 cursor-pointer" onClick={automateSlug}>
                <p className="text-sm text-right text-sky-700 underline">Automate Slug</p>
              </div>
            </div>
          </div>
        )}
        <div
          className="submitBTN"
          style={{ margin: "0 auto", marginTop: 0 }}
          onClick={saveChanges}
        >
          Save Changes
        </div>
      </div>
    </div>
  );
}
